const EXCLUDED_BARBERS = ['Blerton Selmani'];

export { EXCLUDED_BARBERS };
